import React from "react";
import { Row, Col, Tooltip, Button } from "antd";
import { StarOutlined, StarFilled, BarChartOutlined } from "@ant-design/icons";
import CompanyList from "../List/Company.list";
import TagOptions from "../Tag/TagOptions";
import LimitedFeatureBanner from "../../design-library/LimitedFeatureBanner/LimitedFeatureBanner.component";
import { l, formatNumber } from "../../libs/localization";

const CompanySearchResults = ({
  results,
  loading,
  pageSize,
  setPageSize,
  pageNum,
  setPageNum,
  filters,
  tagMode,
  setTagMode,
  selectedTag,
  setSelectedTag,
  tags,
  setSelectedCompanies,
  onAssociateClick,
  onAssociateAllClick,
  onAddTagClick,
  tagAssociationsLoading,
  tagAssociations,
  permissions = {},
  onExportClick,
  loadingExport,
  onRowClick,
  orderLabels,
  onPageChange,
  resultsLimited = false,
  showTags = false,
  showExport = false,
  excludeIds = [],
  showAddButton = false,
  onAddAll,
  consumption,
}) => {
  return (
    <div className="companySearchResults">
      <Row align="middle" className="searchPage__orders">
        {showTags && permissions.favourites && (
          <Tooltip title={l("TAG.ADD_TAG")}>
            <Button
              type="primary"
              shape="circle"
              onClick={() => setTagMode(!tagMode)}
              icon={tagMode ? <StarFilled /> : <StarOutlined />}
            />
          </Tooltip>
        )}

        {showAddButton &&
          results?.companies?.totalResults > 0 &&
          typeof onAddAll === "function" && (
            <Button
              size="large"
              icon={<BarChartOutlined />}
              onClick={onAddAll}
              style={{
                marginRight: 15,
                fontWeight: "bold",
              }}
            >
              {l("PAGES.DASHBOARD.COMPARE_RESULTS")}
            </Button>
          )}

        {orderLabels && (
          <>
            <Col className="orange-title" style={{ marginLeft: 15 }}>
              {l("COMMON.ORDER_BY")}
            </Col>
            <Col flex="none">{orderLabels}</Col>
          </>
        )}

        <Col flex="auto" align="right">
          <Row justify="end">
            <h2 className="orange-title" style={{ margin: 0 }}>
              {l("PAGES.SEARCH.COMPANIES_FOUND")}:{" "}
              <span className="orange-title">
                {formatNumber(results?.companies?.totalResults || 0)}
              </span>
            </h2>
            {showExport &&
              results?.companies?.totalResults > 0 &&
              (permissions.downloadCompanies || permissions.ecommerce) && (
                <Button
                  type="primary"
                  className="ml-3"
                  onClick={onExportClick}
                  loading={loadingExport}
                >
                  {l("TAG.EXPORT_COMPANY")}
                </Button>
              )}
          </Row>
        </Col>
      </Row>

      {showTags && tagMode && (
        <TagOptions
          useId
          onAddTagClick={onAddTagClick}
          tagList={tags}
          value={selectedTag}
          onTagChange={(value) => setSelectedTag(value)}
          onAssociateClick={onAssociateClick}
          associateDisabled={!selectedTag}
          associateAllDisabled={!selectedTag}
          tooManyResultsToAssociateAll={
            !selectedTag || results?.companies?.totalResults > 3000
          }
          onAssociateAllClick={onAssociateAllClick}
        />
      )}

      <CompanyList
        data={results?.companies?.data || []}
        resultsLimited={resultsLimited || results?.companies?.resultsLimited}
        pageSize={pageSize}
        setPageSize={setPageSize}
        total={results?.companies?.totalResults}
        filters={filters}
        tagMode={tagMode}
        setSelectedCompanies={setSelectedCompanies}
        loadingList={loading}
        loadingTag={tagAssociationsLoading}
        associatedTagsIds={tagAssociations}
        page={pageNum}
        onRowClick={onRowClick}
        onPageChange={onPageChange}
        excludeIds={excludeIds}
        showAddButton={showAddButton}
        alreadyOpened={permissions.ecommerce ? consumption?.companies?.ids : []}
      />

      {(resultsLimited || results?.companies?.resultsLimited) && (
        <LimitedFeatureBanner
          message={l("ECOMMERCE.SEARCH_RESULTS_LIMIT_TEXT")}
        />
      )}
    </div>
  );
};

export default CompanySearchResults;
